import React from "react";
import Sidebar from "../../components/Sidebar";
import OrphanedPayoutsPanel from "./components/OrphanedPayoutsPanel";

const OrphanedPayoutsPage = () => {
  return (
    <div className="flex overflow-hidden flex-col h-screen md:flex-row">
      <Sidebar />
      <div className="overflow-y-auto flex-1 p-4 bg-white md:py-7">
        <h1 className="py-4 mb-0 text-xl font-bold md:text-2xl md:mb-6">Treasury: Orphaned Payouts</h1>
        <div>
          <OrphanedPayoutsPanel />
        </div>
      </div>
    </div>
  );
};

export default OrphanedPayoutsPage;
